<template>
  <div class="relative">
    <ValueInput v-if="edit_mode"
                v-model.trim="new_sum"
                label=""
                class="-my-1 budget-edit"
                :currency_id="null"
                @keydownEnter="save"
                ref="input"/>
    <div v-else class="text-text">
      {{ plan_sum }}
      <IconEdit v-if="!currentUserIsWatcher" class="text-icon hover:text-icon-hover
                        opacity-0 group-hover:opacity-100 transition duration-200 cursor-pointer
                        absolute top-0 -right-2 transform translate-x-full z-60"
                @click.native.stop="startEdit"/>
    </div>
    <div v-if="edit_mode" class="actions absolute top-2 -right-2 transform translate-x-full z-60">
      <button class="save focus:outline-none" @click.stop="save" :disabled="isSubmitted">
        <font-awesome-icon class="mr-2 text-green" icon="check"/>
      </button>
      <button class="cancel focus:outline-none" @click.stop="cancelEdit" :disabled="isSubmitted">
        <font-awesome-icon class="text-red" icon="times"/>
      </button>
    </div>
  </div>
</template>

<script>
import ValueInput from "../../../../UI/BaseInput/ValueInput";
import {mapActions, mapGetters, mapMutations} from "vuex";
import IconEdit from "@/components/icons/IconEdit";

export default {
  name: "BudgetItemValueEdit",
  components: {
    IconEdit,
    ValueInput
  },
  data() {
    return {
      edit_mode: false,
      new_sum: null,
      isSubmitted: false
    }
  },
  props: {
    id: {
      required: true
    },
    plan_sum: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    ...mapGetters('space/budgets', ['budgetTypeHelper']),
  },
  methods: {
    ...mapActions('space/budgets', ['updateBudget', 'getBudgets']),
    ...mapMutations('space/budgets', ['setNewSum']),
    prepareSumAsNumber(sum) {
      let preparedSum = sum.split(' ');
      // delete currency symbol
      // preparedSum.pop();
      return +preparedSum.join('');
    },
    startEdit() {
      this.new_sum = this.prepareSumAsNumber(this.plan_sum);
      this.edit_mode = true;
      setTimeout(() => {
        this.$refs.input.$el.querySelector('input').focus()
      }, 1)
    },
    cancelEdit() {
      this.edit_mode = false;
      this.new_sum = null;
    },
    save() {
      let budget_type = this.budgetTypeHelper(this.type);
      const data = {
        id: this.id,
        sum_plan: +this.new_sum,
        budget_type
      };
      this.isSubmitted = true;
      this.updateBudget(data).then(res => {
        if (res.body.success) {
          this.setNewSum(data)
          this.$toasted.success('Бюджет обновлен')
          this.edit_mode = false;
          this.getBudgets()
        } else {
          this.$toasted.error('Ошибка при обновлении бюджета')
        }
        this.isSubmitted = false;
      });

    }
  }
}
</script>

<style lang="scss">
.budget-edit {
  input {
    height: 2rem;
  }
}
</style>